/** Pan the camera by a pixel delta. +dxPx = content dragged right = earlier time into view. */
export function panByPixels(domain: [number, number], dxPx: number, plotWidthPx: number): [number, number] {
  const span = domain[1] - domain[0];
  const dt = (dxPx / Math.max(1, plotWidthPx)) * span;
  return [domain[0] - dt, domain[1] - dt];
}

/**
 * Zoom about a cursor at fraction `cursorFrac` (0=left, 1=right) of the plot.
 * `zoomFactor` > 1 zooms in (smaller span). The timestamp under the cursor is invariant.
 */
export function zoomAboutCursorFrac(
  domain: [number, number],
  cursorFrac: number,
  zoomFactor: number
): [number, number] {
  const span = domain[1] - domain[0];
  const t = domain[0] + cursorFrac * span;
  const newSpan = span / zoomFactor;
  const start = t - cursorFrac * newSpan;
  return [start, start + newSpan];
}

/** Normalize a wheel delta to pixels across deltaMode (0=pixel, 1=line, 2=page). */
export function normalizeWheelDeltaPx(delta: number, deltaMode: number, lineHeightPx = 16, pageHeightPx = 800): number {
  if (deltaMode === 1) return delta * lineHeightPx;
  if (deltaMode === 2) return delta * pageHeightPx;
  return delta;
}
